// extracted by mini-css-extract-plugin
module.exports = {"error":"_1IaAa","fundIdError":"_7qxRP"};